<template>
    <div class="text-left bg-gray-800 rounded-md shadow-lg p-3 flex flex-wrap">
        <div class="pt-1 mr-5 hidden lg:block">
            <div class="text-gray-200 uppercase text-xxs font-semibold leading-none tracking-wide">
                Filter
            </div>

            <i aria-hidden="true" class="material-icons text-gray-200 text-3xl block" style="margin-left: 2px;">filter_list</i>
        </div>

        <div class="">
            <div class="select-none text-white text-xs font-semibold pb-1">
                View Entries from:
            </div>

            <div class="flex items-center py-1">
                <toggle-button
                    @change="toggleAuthor"
                    :value="showAuthorIds.includes(self_id)"
                    :tag="self_id.toString()"
                    :color="{checked: '#76d572', unchecked: '#6e6d7e'}"
                    :width="26"
                    :height="15"
                    :margin="1"
                    :speed="100"
                    :sync="true"
                    ref="yourself"
                />

                <div class="select-none text-white text-xxs ml-2 cursor-pointer"
                    @click="$refs.yourself.$el.click()"
                >
                    Yourself
                </div>
            </div>

            <div v-for="author in authors">
                <div v-if="author.id != self_id" class="flex items-center py-1">
                    <toggle-button
                        @change="toggleAuthor"
                        :value="showAuthorIds.includes(author.id)"
                        :tag="author.id.toString()"
                        :color="{checked: '#76d572', unchecked: '#6e6d7e'}"
                        :width="26"
                        :height="15"
                        :margin="1"
                        :speed="100"
                        :ref="'author_' + author.id"
                    />

                    <div class="select-none text-white text-xxs ml-2 cursor-pointer"
                        @click="clickAuthorToggle(author.id)"
                    >
                        {{ author.name }}
                    </div>
                </div>
            </div>
        </div>

        <div class="pl-8 ">
            <div class="select-none text-white text-xs font-semibold pb-1">
                Entry Type:
            </div>

            <div class="flex items-center py-1">
                <toggle-button
                    @change="toggleType"
                    :value="showTypes.includes('highlight')"
                    tag="highlight"
                    :color="{checked: '#76d572', unchecked: '#6e6d7e'}"
                    :width="26"
                    :height="15"
                    :margin="1"
                    :speed="100"
                    :sync="true"
                    ref="highlight"
                />

                <div class="select-none text-xxs text-yellow-400 ml-2 cursor-pointer"
                    @click="$refs.highlight.$el.click()"
                >
                    <i aria-hidden="true" class="material-icons text-base absolute">highlight</i>
                    <span class="pl-5">Highlight</span>
                </div>
            </div>

            <div class="flex items-center py-1">
                <toggle-button
                    @change="toggleType"
                    :value="showTypes.includes('strikethrough')"
                    tag="strikethrough"
                    :color="{checked: '#76d572', unchecked: '#6e6d7e'}"
                    :width="26"
                    :height="15"
                    :margin="1"
                    :speed="100"
                    :sync="true"
                    ref="strikethrough"
                />

                <div class="select-none text-xxs text-red-400 ml-2 cursor-pointer"
                    @click="$refs.strikethrough.$el.click()"
                >
                    <i aria-hidden="true" class="material-icons text-base absolute">strikethrough_s</i>
                    <span class="pl-5">Strikethrough</span>
                </div>
            </div>

            <div class="flex items-center py-1">
                <toggle-button
                    @change="toggleType"
                    :value="showTypes.includes('task')"
                    tag="task"
                    :color="{checked: '#76d572', unchecked: '#6e6d7e'}"
                    :width="26"
                    :height="15"
                    :margin="1"
                    :speed="100"
                    :sync="true"
                    ref="task"
                />

                <div class="select-none text-xxs text-green-300 ml-2 cursor-pointer"
                    @click="$refs.task.$el.click()"
                >
                    <i aria-hidden="true" class="material-icons text-base absolute">add_task</i>
                    <span class="pl-5">Task</span>
                </div>
            </div>

            <div class="flex items-center py-1">
                <toggle-button
                    @change="toggleType"
                    :value="showTypes.includes('comment')"
                    tag="comment"
                    :color="{checked: '#76d572', unchecked: '#6e6d7e'}"
                    :width="26"
                    :height="15"
                    :margin="1"
                    :speed="100"
                    :sync="true"
                    ref="comment"
                />

                <div class="select-none text-xxs text-indigo-300 ml-2 cursor-pointer"
                    @click="$refs.comment.$el.click()"
                >
                    <i aria-hidden="true" class="material-icons text-base absolute">add_comment</i>
                    <span class="pl-5">Comment Only</span>
                </div>
            </div>

            <div v-if="enable_private_annotations" class="flex items-center py-1">
                <toggle-button
                    @change="toggleType"
                    :value="showTypes.includes('private')"
                    tag="private"
                    :color="{checked: '#76d572', unchecked: '#6e6d7e'}"
                    :width="26"
                    :height="15"
                    :margin="1"
                    :speed="100"
                    :sync="true"
                    ref="private"
                />

                <div class="select-none text-xxs text-orange-300 ml-2 cursor-pointer"
                    @click="$refs.private.$el.click()"
                >
                    <i aria-hidden="true" class="material-icons text-base absolute">lock</i>
                    <span class="pl-5">Private</span>
                </div>
            </div>

            <div v-if="enable_private_annotations" class="flex items-center py-1">
                <toggle-button
                    @change="toggleType"
                    :value="showTypes.includes('journal')"
                    tag="journal"
                    :color="{checked: '#76d572', unchecked: '#6e6d7e'}"
                    :width="26"
                    :height="15"
                    :margin="1"
                    :speed="100"
                    :sync="true"
                    ref="journal"
                />

                <div class="select-none text-xxs text-teal-300 ml-2 cursor-pointer"
                    @click="$refs.journal.$el.click()"
                >
                    <i aria-hidden="true" class="material-icons text-base absolute">phonelink_lock</i>
                    <span class="pl-5">Journal</span>
                </div>
            </div>
        </div>

        <div  class="pl-8 ">
            <div class="select-none text-white text-xs font-semibold pb-1">
                Comments:
            </div>

            <div class="flex items-center py-1">
                <toggle-button
                    @change="toggleComments"
                    :value="showComments.includes('with')"
                    tag="with"
                    :color="{checked: '#76d572', unchecked: '#6e6d7e'}"
                    :width="26"
                    :height="15"
                    :margin="1"
                    :speed="100"
                    :sync="true"
                    ref="with_comments"
                />

                <div class="select-none text-white text-xxs ml-2 cursor-pointer"
                    @click="$refs.with_comments.$el.click()"
                >
                    With Comments
                </div>
            </div>

            <div class="flex items-center py-1">
                <toggle-button
                    @change="toggleComments"
                    :value="showComments.includes('without')"
                    tag="without"
                    :color="{checked: '#76d572', unchecked: '#6e6d7e'}"
                    :width="26"
                    :height="15"
                    :margin="1"
                    :speed="100"
                    :sync="true"
                    ref="without_comments"
                />

                <div class="select-none text-white text-xxs ml-2 cursor-pointer"
                    @click="$refs.without_comments.$el.click()"
                >
                    Without Comments
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'

export default {
    components: {
        ToggleButton,
    },

    props: {
        annotations: {},
        self_id: {},
        enable_private_annotations: { type: Boolean, default: false },
    },

    data() {
        return {
            authors: [],
            showAuthorIds: [],
            showTypes: this.enable_private_annotations
                ? ['highlight', 'strikethrough', 'comment', 'task', 'private', 'journal']
                : ['highlight', 'strikethrough', 'comment', 'task'],
            showComments: ['with', 'without'],
        }
    },

    computed: {
        filtered_annotations() {
            return this.annotations.filter(annotation => {
                return this.showAuthorIds.includes(annotation.author_id)
                    && this.showTypes.includes(annotation.type)
                    && this.showComments.includes(this.hasComments(annotation) ? 'with' : 'without');
            });
        }
    },

    methods: {
        toggleAuthor({ value, tag }) {
            if (value == true) {
                this.showAuthorIds.push(parseInt(tag));
            } else {
                this.showAuthorIds.splice(this.showAuthorIds.indexOf(parseInt(tag)), 1);
            }
        },
        toggleType({ value, tag }) {
            if (value == true) {
                this.showTypes.push(tag);
            } else {
                this.showTypes.splice(this.showTypes.indexOf(tag), 1);
            }
        },
        toggleComments({ value, tag }) {
            if (value == true) {
                this.showComments.push(tag);
            } else {
                this.showComments.splice(this.showComments.indexOf(tag), 1);
            }
        },
        hasComments(annotation) {
            return annotation.comments ? annotation.comments.length > 0 : false;
        },
        clickAuthorToggle(id) {
            let ref_id = 'author_' + id;
            this.$refs[ref_id][0].$el.click();
        },
    },

    created() {
        this.authors = _.uniqBy(this.annotations, 'author_id').map(annotation => {
            return {
                id: annotation.author_id,
                name: annotation.author_name,
            };
        });

        this.showAuthorIds = this.authors.map(author => author.id)
    },

    watch: {
        filtered_annotations: {
            handler(val) {
                this.$emit('filtered', val)
            },
            immediate: true,
        },
    },
}
</script>

